@if (meetingData.meetingId) {
  <p-button
    size="small"
    type="button"
    pTooltip="Dieses Meeting anzeigen und bearbeiten — wirkt nur auf diesen Unterrichtstag, nicht auf die Vorlage"
    tooltipPosition="bottom"
    [icon]="isLoadingTeamsMeeting ? 'pi pi-spin pi-spinner' : 'pi pi-pencil'"
    [rounded]="true"
    [text]="true"
    severity="secondary"
    (onClick)="openTeamsMeetingDialog($event)"
  >
  </p-button>

  <app-link-button
    tooltipPosition="bottom"
    tooltip="Öffnet das Teams Meeting in einem neuen Tab."
    [href]="meetingData?.meetingLink"
    target="_blank"
    iconRight="pi pi-arrow-up-right"
    styleClass="p-button-rounded p-button-text p-button-secondary"
  ></app-link-button>
  <!-- Copy link -->
  <p-button
    size="small"
    type="button"
    pTooltip="Beitrittslink kopieren"
    tooltipPosition="bottom"
    icon="pi pi-copy"
    [rounded]="true"
    [text]="true"
    severity="secondary"
    (onClick)="copyToClipboard(meetingData?.meetingLink)"
  ></p-button>
} @else {
  <p-button
    pTooltip="Legt ab heute für jeden Schultag ein Teams-Meeting an. Wie weit das reicht, ist serverseitig konfiguriert und unabhängig vom Anzeigefilter."
    tooltipPosition="bottom"
    size="small"
    type="button"
    label="Meetings erstellen"
    icon="pi pi-plus"
    severity="primary"
    (onClick)="openTeamsMeetingDialog($event)"
  >
  </p-button>
}
